export const logWarning = (...args: any[]) => {
    console.warn(...args);
};

export const logError = (...args: any[]) => {
    console.error(...args);
};

export const stringifyError = (error: any) => {

    if (!(error instanceof Error)) {
        try {
            return JSON.stringify(error);
        } catch (e) {
            console.error('Failed to serialize error to JSON.', e);
            return e + '';
        }
    }

    return JSON.stringify({
        fileName:     (error as any).fileName,
        lineNumber:   (error as any).lineNumber,
        columnNumber: (error as any).columnNumber,
        message:      error.message,
        name:         error.name,
        stack:        error.stack
    });
};